import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import imageUpload from "../../../services/upload";
import { TextField } from "@mui/material";
import bannerService from "../../../services/bannerService";
import {
  EditPageLayout,
  EditImageSection,
  EditFieldLabel,
  EditFormTopSection,
} from "../../../components/edit/EditPageLayout";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
import { createNewBannerSchema } from "../../../schema/createNewBannerSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];
export default function UpdateBanner({ homeAlert }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [nameEng, setNameEng] = useState("");
  const [nameMM, setNameMM] = useState("");
  const [link, setLink] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");
  const [values, setValues] = useState({ image_url: "" });
  const [banners, setBanners] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createNewBannerSchema),
    initalValues: {
      name_en: "",
      name_mm: "",
      link: "",
    },
  });

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    console.log(result);
    const path = IMAGE_PATH + result?.imageName;
    console.log("path=============>", path);
    setImageFileUrl(result?.imageUploadUrl);
    setValues({
      ...values,
      image_url: path,
    });
  }
  useEffect(() => {
    if (!banners) {
      fetchBanners();
    }
  }, []);

  useEffect(() => {
    setNameMM(banners?.name_mm);
    setNameEng(banners?.name_en);
    setLink(banners?.link);

    if (banners) {
      setValue("name_en", banners?.name_en);
      setValue("name_mm", banners?.name_mm);
      setValue("link", banners?.link);

      setValues({
        image_url: banners?.image_url || "",
      });
    }
  }, [banners, setValue]);

  const fetchBanners = async () => {
    try {
      const res = await bannerService.getOneBanner(instanceToken.token, id);
      setBanners(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  const changeNameMM = (e) => {
    setNameMM(e.target.value);
  };
  const changeNameEng = (e) => {
    setNameEng(e.target.value);
  };
  const changeLink = (e) => {
    setLink(e.target.value);
  };

  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const img = e.target.files[0];
      if (!imgFileTypes.includes(img.type)) {
        setErrorMessage({
          ...errorMessage,
          image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
        });
        return;
      }
      if (img.size > 204800) {
        setErrorMessage({
          ...errorMessage,
          image_url: "Image file size must be smaller than 200KB.",
        });
        return;
      }
      setImageFile(img);
      setImagePreview(URL.createObjectURL(img));
      getImageUrl(img);
    }
  };

  const formData = new FormData();
  const handleUpdate = async (data) => {
    // e.preventDefault();

    formData.append("name_en", data?.name_en);
    formData.append("name_mm", data?.name_mm);
    formData.append("link", data?.link);
    formData.append(
      "image_url",
      values?.image_url ? values?.image_url : data?.image_url
    );
    formData.append("image_data", "");

    try {
      setLoading(true);
      if (imageFile) {
        await imageUpload.uploadImage(imageFileUrl, imageFile);
      }
      const response = await bannerService.putBanner(
        instanceToken.token,
        id,
        formData
      );
      navigate("/banners");
      setBanners(response.data);
      homeAlert("News banners have been updated.", false);
      // setLoading(false);
    } catch (error) {
      console.log(error);
      homeAlert("Error on server.", true);
    } finally {
      setLoading(false);
      setErrorMessage({});
    }
  };

  const handleRemove = async () => {
    try {
      await bannerService.deleteBanner(instanceToken.token, id);
      homeAlert("Banner post have been removed.", false);
      navigate("/banners");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <EditPageLayout
      title="Edit Banner"
      subtitle="Update your banner details and image."
      breadcrumbs={[
        { label: "Banners", path: "/banners" },
        { label: `Banner (ID - ${id})`, path: `/banners/${id}` },
        { label: "Edit" },
      ]}
      detailPath={`/banners/${id}`}
      onRemove={handleRemove}
      loading={loading}
      onSubmit={handleSubmit(handleUpdate)}
      removeMessage="Are you sure you want to remove this banner?"
    >
      <EditFormTopSection
        image={
          <EditImageSection
            uploadLabel="Banner Image"
            previewLabel="Image Preview"
            imageUrl={values?.image_url}
            imagePreview={imagePreview}
            onFileChange={changeFile}
            error={errorMessage["image_url"]}
            recommendedSize="1920 x 1200 px (16:10)"
          />
        }
      >
        <div>
          <EditFieldLabel required>Name (English)</EditFieldLabel>
          <TextField
            fullWidth
            id="name_en"
            {...register("name_en")}
            onChange={changeNameEng}
            value={nameEng}
            error={!!errors.name_en}
            helperText={errors.name_en?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Name (Myanmar)</EditFieldLabel>
          <TextField
            fullWidth
            id="name_mm"
            {...register("name_mm")}
            onChange={changeNameMM}
            value={nameMM}
            error={!!errors.name_mm}
            helperText={errors.name_mm?.message}
          />
        </div>
        <div>
          <EditFieldLabel required>Link</EditFieldLabel>
          <TextField
            fullWidth
            id="link"
            {...register("link")}
            onChange={changeLink}
            value={link}
            error={!!errors.link}
            helperText={errors.link?.message}
          />
        </div>
      </EditFormTopSection>
    </EditPageLayout>
  );
}
